export default "__VITE_ASSET__Bdqv7lql__"